module.exports = __webpack_public_path__ + "static/img/lead-and-deliver copy.cdb49dfe.png";